export function Button({ onClick, children, classNameExtension }) {
  return (
    <button
      onClick={onClick}
      className={`${classNameExtension} flex items-center justify-center text-white p-3 rounded-md`}
    >
      {children}
    </button>
  );
}

export function ButtonPrimary({ onClick, children, className }) {
  return (
    <Button onClick={onClick} classNameExtension={`bg-primary ${className}`}>
      {children}
    </Button>
  );
}

export function ButtonSecondary({ onClick, children, className }) {
  return (
    <Button onClick={onClick} classNameExtension={`bg-secondary ${className}`}>
      {children}
    </Button>
  );
}
